import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from './supabaseClient';
import { clearSingleSession } from './AuthContext';

export default function ProfileMenu() {
  const [open, setOpen] = useState(false);
  const [avatarUrl, setAvatarUrl] = useState('');
  const menuRef = useRef();
  const navigate = useNavigate();

  // Fetch user's avatar on component mount
  useEffect(() => {
    const fetchUserAvatar = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        const { data: profile } = await supabase
          .from('profiles')
          .select('avatar_url')
          .eq('user_id', user.id)
          .single();
        
        if (profile?.avatar_url) {
          setAvatarUrl(profile.avatar_url);
        }
      }
    };
    fetchUserAvatar();
  }, []);

  // Close menu when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div style={{ position: 'relative' }} ref={menuRef}>
      <img
        src={avatarUrl || 'https://www.svgrepo.com/show/384674/account-avatar-profile-user-11.svg'}
        alt="User"
        style={{ borderRadius: '50%', width: 40, height: 40, cursor: 'pointer', objectFit: 'cover' }}
        onClick={() => setOpen(o => !o)}
      />
      {open && (
        <div style={{
          position: 'absolute',
          right: 0,
          top: 48,
          background: '#fff',
          borderRadius: 8,
          boxShadow: '0 2px 8px #0002',
          minWidth: 160,
          zIndex: 10,
          padding: 8
        }}>
          <div
            style={{ padding: '10px 16px', cursor: 'pointer', borderRadius: 6 }}
            onClick={() => { setOpen(false); navigate('/profile'); }}
          >
            Edit Profile
          </div>
          <div
            style={{ padding: '10px 16px', cursor: 'pointer', borderRadius: 6, color: '#e74c3c' }}
            onClick={async () => {
              setOpen(false);
              const { data: { user } } = await supabase.auth.getUser();
              if (user) {
                await supabase.auth.signOut();
              }
              localStorage.clear();
              navigate('/');
            }}
          >
            Logout
          </div>
        </div>
      )}
    </div>
  );
}
